import Library from 'library'

export function getSearchableEntities () {
  return Library.Config.Entities.SearchableEntities
}

export function getMetaDataEntities () {
  return Library.Config.Entities.MetaDataEntities
}

// Search Entities

export function hasSearchComponent (type) {
  try {
    if (require(`@/views/Entities/${type}/Search.vue`)) {
      return true
    }
  } catch (e) {
    // Ignore if the file is not present
  }

  return false
}

export function getSearchComponent (type) {
  if (hasSearchComponent(type)) {
    return require(`@/views/Entities/${type}/Search.vue`).default
  } else {
    return require(`@/views/Search/Search.vue`).default
  }
}

export function isSearchableEntity (type) {
  if (hasSearchComponent(type)) {
    return true
  }

  if (getSearchableEntities().indexOf(type) !== -1) {
    return true
  }

  return false
}

export function hasCreateComponent (type) {
  try {
    if (require(`@/views/Entities/${type}/Create.vue`)) {
      return true
    }
  } catch (e) {
    // Ignore if the file is not present
  }

  return false
}

export function hasCreate (type) {
  try {
    if (hasCreateComponent(type)) {
      return true
    }
  } catch (e) {
    // Ignore if the file is not present
  }

  try {
    if (Library.Entities.getCreateFields(type)) {
      return true
    }
  } catch (e) {
    // Ignore if the file is not present
  }

  return false
}

export function getCreateComponent (type) {
  try {
    if (hasCreateComponent(type)) {
      return require(`@/views/Entities/${type}/Create.vue`).default
    }

    if (Library.Entities.getCreateFields(type)) {
      return require(`@/components/ViewComponents/CreateComponent.vue`).default
    }
  } catch (e) {
    return null
  }
}

export function getCreatePath (type) {
  if (type in Library.Config.Entities) {
    if (Library.Config.Entities[type].CreatePath) {
      return Library.Config.Entities[type].CreatePath
    }
  }

  return `/${Library.Filters.toUrlCase(type)}/create`
}

export function hasViewComponent (type) {
  try {
    if (require(`@/views/Entities/${type}/View.vue`)) {
      return true
    }
  } catch (e) {
    // Ignore if the file is not present
  }

  return false
}

export function hasView (type) {
  try {
    if (hasViewComponent(type)) {
      return true
    }
  } catch (e) {
    // Ignore if the file is not present
  }

  try {
    if (Library.Entities.getEditFields(type)) {
      return true
    }
  } catch (e) {
    // Ignore if the file is not present
  }

  return false
}

export function getViewComponent (type) {
  try {
    if (hasViewComponent(type)) {
      return require(`@/views/Entities/${type}/View.vue`).default
    }

    return require('@/components/ViewComponents/ViewComponent.vue').default
  } catch (e) {
    return null
  }
}

export function getViewPath (type) {
  if (type in Library.Config.Entities) {
    if (Library.Config.Entities[type].ViewPath) {
      return Library.Config.Entities[type].ViewPath
    }
  }

  return `/${Library.Filters.toUrlCase(type)}/:id`
}
